<template>
  <v-container>
    <v-row justify="center">
      <v-progress-circular
        indeterminate
        color="primary-lighten-1"
      />
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import { useOidc } from '@/composables/oidc';

export default {
  name: 'OidcCallback',
  setup() {
    const { oidcSignInCallback } = useOidc();
    return { oidcSignInCallback };
  },
  methods: {
    ...mapActions('oidcStore', [
      'oidcSignInCallback'
    ])
  },
  async created() {
    try {
      const redirectPath = await this.oidcSignInCallback();
      this.$router.push(redirectPath);
    } catch {
      this.$router.push('/signin-oidc-error');
    }
  }
};
</script>
